import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, User as UserIcon, ShoppingBag } from 'lucide-react';
import { Logo } from './Logo';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';
export function SiteNav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const {
    user
  } = useAuth();
  const {
    itemCount,
    openCart
  } = useCart();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Training',
    path: '/training'
  }, {
    name: 'Shop',
    path: '/shop'
  }, {
    name: 'Books',
    path: '/books'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-charcoal/95 backdrop-blur-md py-4 shadow-md' : 'bg-transparent py-6'}`} data-id="element-2616">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-2617">
        <Link to="/" className="flex items-center gap-3 group" data-id="element-2618">
          <Logo className="w-10 h-10 transition-transform group-hover:scale-105" data-id="element-2619" />
          <span className="font-serif text-white text-xl hidden sm:block" data-id="element-2620">
            Jack Achenbach
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-2621">
          {navLinks.map(link => <Link key={link.name} to={link.path} className="text-xs font-bold text-[#D8D8D0] uppercase tracking-[0.2em] hover:text-white transition-colors relative group" data-id="element-2622">
              {link.name}
              <span className="absolute -bottom-2 left-0 w-0 h-0.5 bg-tealslate transition-all duration-300 group-hover:w-full" data-id="element-2623" />
            </Link>)}
          <Link to={user ? '/account' : '/login'} className="ml-2 inline-flex items-center gap-2 px-4 py-2 border border-tealslate text-tealslate hover:bg-tealslate hover:text-white text-xs font-bold uppercase tracking-[0.2em] transition-colors" data-id="element-2624">
            <UserIcon className="w-3.5 h-3.5" data-id="element-2625" />
            {user ? 'Account' : 'Sign In'}
          </Link>
          <button onClick={openCart} className="relative inline-flex items-center justify-center w-10 h-10 text-[#D8D8D0] hover:text-white transition-colors" aria-label={`Open cart, ${itemCount} ${itemCount === 1 ? 'item' : 'items'}`} data-id="element-2626">
            <ShoppingBag className="w-5 h-5" data-id="element-2627" />
            {itemCount > 0 && <span className="absolute -top-1 -right-1 bg-tealslate text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center" data-id="element-2628">
                {itemCount}
              </span>}
          </button>
        </nav>

        {/* Mobile cart icon */}
        <button onClick={openCart} className="md:hidden relative inline-flex items-center justify-center w-10 h-10 text-white mr-2" aria-label={`Open cart, ${itemCount} ${itemCount === 1 ? 'item' : 'items'}`} data-id="element-2629">
          <ShoppingBag className="w-5 h-5" data-id="element-2630" />
          {itemCount > 0 && <span className="absolute top-0 right-0 bg-tealslate text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center" data-id="element-2631">
              {itemCount}
            </span>}
        </button>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-2632">
          {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-2633" /> : <Menu className="w-6 h-6" data-id="element-2634" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-charcoal border-t border-darkgray shadow-xl" data-id="element-2635">
          <nav className="flex flex-col py-4" data-id="element-2636">
            {navLinks.map(link => <Link key={link.name} to={link.path} className="px-6 py-4 text-sm font-bold text-[#D8D8D0] uppercase tracking-[0.2em] hover:bg-darkgray hover:text-white transition-colors" data-id="element-2637">
                {link.name}
              </Link>)}
            <Link to={user ? '/account' : '/login'} className="px-6 py-4 text-sm font-bold text-tealslate uppercase tracking-[0.2em] hover:bg-darkgray transition-colors border-t border-darkgray flex items-center gap-2" data-id="element-2638">
              <UserIcon className="w-4 h-4" data-id="element-2639" />
              {user ? 'Account' : 'Sign In'}
            </Link>
          </nav>
        </div>}
    </header>;
}